/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const DeliveryDocketPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * Docket information
   */
  docket: PropTypes.any,

  /**
   * actions e.g. for analytics tracking
   */
  actions: PropTypes.object.isRequired,

  /**
   * Error callback
   */
  onError: PropTypes.func,

  /**
   * When activities being refreshed callback, e.g. when switched to "activity" tab
   */
  onRefreshActivities: PropTypes.func,

  /**
   * When docket is being unnacepted
   */
  onUnaccept: PropTypes.func,

  /**
   * Activities to be displayed
   */
  activities: PropTypes.array.isRequired,

  /**
   * The width of the screen. Provided by @material-ui/core/withWidth
   */
  width: PropTypes.string.isRequired,
};

export default DeliveryDocketPropTypes;
